function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "7.5",
  viewBox: "0 0 12 7.5",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 0L6 4.5 10.5 0 12 1.5l-6 6-6-6z",
  fillRule: "evenodd"
})));